import e80days from '../../Images/dvd_pic/80days_1.jpg';
import ukraine from '../../Images/dvd_pic/ukraine_2.jpeg';
import cnn from '../../Images/dvd_pic/cnn_2.jpeg';
import full_bloom from '../../Images/dvd_pic/full_bloom.jpeg';
import foodtastic from '../../Images/dvd_pic/foodtastic.jpeg';
import masterchef_3 from '../../Images/dvd_pic/masterchef_3.jpeg';
import alaska from '../../Images/dvd_pic/alaska.jpg';
import one_heart_3 from '../../Images/dvd_pic/one_heart_3.jpeg';
import ourhome from '../../Images/dvd_pic/ourhome.jpg';
import revolution_1 from '../../Images/dvd_pic/revolution_2.jpg';
import gabe_3 from '../../Images/dvd_pic/gabe_3.jpg';
import lostboys_4 from '../../Images/dvd_pic/lostboys_4.jpeg';
import voicethroughstorm from '../../Images/dvd_pic/voicethroughstorm.png';
import ladybug from '../../Images/dvd_pic/ladybug_2.jpeg';
import ladybug_3 from '../../Images/dvd_pic/ladybug_3.jpeg';
import thisremains from '../../Images/dvd_pic/thisremains.jpeg';

import e80days_banner from '../../Images/banners/80days_banner_2.png';
import cnn_banner from '../../Images/banners/cnn_banner_2.png';
import gabe_banner from '../../Images/banners/gabe_banner_2.png';
import ladybug_banner from '../../Images/banners/ladybug_banner.png';
import ladybug_animation_banner from '../../Images/banners/ladybug_animation.png';
import lostboys_banner from '../../Images/banners/lostboys_banner.png';
import masterchef_banner from '../../Images/banners/masterchef_banner_2.png';
import revolution_banner from '../../Images/banners/revolution_banner_2.png';
import ukraine_banner from '../../Images/banners/ukraine_banner_2.png';
import thisremains_banner from '../../Images/banners/thisremains_banner.png';
import voicethroughstorm_banner from '../../Images/banners/voicethroughstorm_banner.png';
import foodtastic_banner from '../../Images/banners/foodtastic_banner.png';
import fullbloom_banner from '../../Images/banners/fullbloom_banner.png';
import alaska_banner from '../../Images/banners/alaska_banner_2.png';
import oneheart_banner from '../../Images/banners/oneheart_banner.png';
import ourhome_banner from '../../Images/banners/ourhome_banner.png';

// import eighty_days_video from '../../Images/clips/80days_small.mp4';
// import cnn_clip_1 from '../../Images/clips/cnn_clip_1.mp4';
// import cnn_clip_2 from '../../Images/clips/cnn_clip_2.mp4';
// import gabe_clip_2 from '../../Images/clips/gabe_clip_2.mp4';
// import ladybug_clip from '../../Images/clips/ladybug_clip.mp4';
// import lostboys_clip_2 from '../../Images/clips/lostboys_clip_2.mp4';
// import ourhome_clip from '../../Images/clips/ourhome_clip.mp4';
// import revolution_clip from '../../Images/clips/revolution_clip.mp4';

import alaska_song_1 from '../../Audio/alaska1.mp3';
import cnn_song_1 from '../../Audio/cnn1.mp3';
import gabe_song_1 from '../../Audio/gabe1.mp3';
import gabe_song_2 from '../../Audio/gabe2.mp3';
import gabe_song_3 from '../../Audio/gabe3.mp3';
import gabe_song_4 from '../../Audio/gabe4.mp3';
import ladybug_song_1 from '../../Audio/ladybug1.mp3';
import ladybug_song_2 from '../../Audio/adventurepark1.mp3';
import ourhome_song_1 from '../../Audio/ourhome1.mp3';
import ourhome_song_2 from '../../Audio/ourhome2.mp3';
import ourhome_song_3 from '../../Audio/ourhome3.mp3';
import remains_song_1 from '../../Audio/remains1.mp3';
import remains_song_2 from '../../Audio/remains2.mp3';
import remains_song_3 from '../../Audio/remains3.mp3';
import masterchef_audio from '../../Audio/masterchef.wav';

import aroundworld_still from '../../Images/clip_stills/aroundworld_still.png';
import ben_stiller_still from '../../Images/clip_stills/ben_stiller_still.png';
import choke_still from '../../Images/clip_stills/choke_still.png';
import conducting_still from '../../Images/clip_stills/conducting_still.png';
import ironlung_still from '../../Images/clip_stills/ironlung_still.png';
import jason_sudeikis_still from '../../Images/clip_stills/jason_sudeikis_still.png';
import ladybug_still from '../../Images/clip_stills/ladybug_still.png';
import lostboy_still from '../../Images/clip_stills/lostboy_still.png';
import opening_still from '../../Images/clip_stills/opening_still.png';
import outhome_still from '../../Images/clip_stills/outhome_still.png';
import remains_still from '../../Images/clip_stills/remains_still.png';
import voicethroughstorm_still from '../../Images/clip_stills/voicethroughstorm_still.png';
import ukraine_still from '../../Images/clip_stills/ukraine_still.png';

const FilmScoreData = [
	{
		id: 0,
		name: 'Around The World In 80 Days',
		director: 'Staring David Tennant',
		points: ['Staring David Tennant','Created by Ashley Pharoah & Caleb Ranson'],
		description: 'Around the World in 80 Days is a period drama adventure television series based on the 1873 Jules Verne novel of the same name, in which, as a bet, Phileas Fogg travels the world in 80 days by train and ship.',
		info: ['Around The World In 80 Days (2022)','BBC','Bleeding Fingers','Additional Music'],
		thumbnail: e80days,
		// video: eighty_days_video,
		banner: e80days_banner,
		brands: ['bbc','bleeding_fingers'],
		songs: [],
		// clips: [{name:'Around The World In 80 Days clip',video:eighty_days_video}],
		clips: [{name:'Around The World In 80 Days clip',spanClass:'wistia_embed wistia_async_xpzo48ztwk popover=true popoverAnimateThumbnail=true',still:aroundworld_still}],
		link: 'https://www.imdb.com/title/tt9174578/',
	},
	{
		id: 1,
		name: 'Vox - Russia & Ukrainian War',
		director: '10 million+ views on Youtube',
		points: ['10 million+ views on Youtube','Vox Media'],
		description: 'On February 24th, Russia launched a military invasion of Ukraine. Russian President Vladimir Putin called it a “special military operation,” but the scale of the attack shows this is a full-scale war that has already caused more than 100 casualties and forced more than half a million Ukrainians to flee their homes.',
		info: [`Vox - Putin's war on Ukraine, explained`,'Vox Media','Youtube','Additional Music'],
		thumbnail: ukraine,
		// video: ukraine_clip,
		banner: ukraine_banner,
		brands: ['vox','youtube'],
		songs: [],
		// clips: [{name:'Vox - Russia & Ukrainian War',video:ukraine_clip}],
		clips: [{name:'Vox - Russia & Ukrainian War',spanClass:'wistia_embed wistia_async_7jdz9g8z5i popover=true popoverAnimateThumbnail=true',still:ukraine_still}],
		links: [{name:'Youtube video',link:'https://www.youtube.com/watch?v=MVu8QbxafJE&t=0s'},{name:'Learn more',link:'https://www.vox.com/2022/2/23/22948534/russia-ukraine-war-putin-explosions-invasion-explained'}],
		// youtube_still: ukraine_still,
	},
	{
		id: 2,
		name: 'Rex Chapman CNN +',
		points: ['CNN+'],
		description: 'NBA and Kentucky college basketball star Rex Chapman is joining CNN as a host for CNN+, the much-anticipated streaming subscription service that will debut in Q1 2022.',
		info: ['Rex Chapman CNN+ (2022)','CNN +','Bleeding Fingers','Thematic Composer'],
		thumbnail: cnn,
		banner: cnn_banner,
		brands: ['cnn_plus','bleeding_fingers'],
		songs: [{audio:cnn_song_1,name:'Rex Chapman CNN+ Theme Song'}],
		// clips: [{name:'Ben Stiller Interview',video:cnn_clip_1},{name:'Jason Sudeikis Interview',video:cnn_clip_2}],
		clips: [{name:'Ben Stiller Interview',spanClass:'wistia_embed wistia_async_b20cpyh5hf popover=true popoverAnimateThumbnail=true',still:ben_stiller_still},
				{name:'Jason Sudeikis Interview',spanClass:'wistia_embed wistia_async_ywjjdb7wzo popover=true popoverAnimateThumbnail=true',still:jason_sudeikis_still}],
		// links: [{name:'',link:'https://cnnpressroom.blogs.cnn.com/2022/01/18/rex-chapman-joins-cnn/'}],
	},
	{
		id: 6,
		name: 'Alaskan Bush People',
		points: [],
		description: 'Alaskan Bush People is an American docudrama-style reality television series that follows the Brown family in an attempt to survive in the wilderness, detached from modern society.',
		info: [`Alaskan Bush People (2021)`,`Discovery`,`Bleeding Fingers`,`Park Slope Productions`,`Additional Music`],
		thumbnail: alaska,
		banner: alaska_banner,
		brands: ['discovery','bleeding_fingers'],
		songs: [{audio:alaska_song_1,name:'Uphill Battles'}],
		clips: [],
	},
	{
		id: 8,
		name: 'This Is Our Home',
		points: ['Directed by Omri Dorani'],
		director: 'Directed by Omri Dorani',
		description: `A struggling couple's weekend getaway goes awry when a child arrives in the middle of the night claiming to be their son.`,
		info: [`This Is Our Home (2020)`,`Directed by: Omri Dorani`,`Uncork'd Entertainment`,`Amazon Prime`,`Composer`],
		thumbnail: ourhome,
		// video: ourhome_clip,
		banner: ourhome_banner,
		brands: ['prime'],
		songs: [{audio:ourhome_song_1,name:'Our Home'},{audio:ourhome_song_2,name:'Glass Door Arguments'},{audio:ourhome_song_3,name:'The Room Calls'}],
		// clips: [{name:'This Is Our Home Trailer',video:ourhome_clip}],
		clips: [{name:'This Is Our Home Trailer',spanClass:'wistia_embed wistia_async_f91pjxdcvx popover=true popoverAnimateThumbnail=true',still:outhome_still}],
		links: [{name:'Watch on Amazon',link:'https://www.amazon.com/This-Our-Home-Jeff-Ayars/dp/B07ZZKXFSP'}],
	},
	{
		id: 9,
		name: 'Conducting A Revolution',
		director: 'Directed by Bella Monticelli-McTiernan',
		points: ['Directed by Bella Monticelli-McTiernan'],
		description: `Speranza Scappucci is paving a new path for women in the competitive, male-dominated field of music conducting; her passion and determination have propelled her success thus far, and now she faces a new challenge that's more personal.`,
		info: [`Conducting A Revolution (2018)`,`Directed by Bella Monticelli-McTiernan`,`Bvlgari`,`Tribeca Film Festival`,`Composer`],
		thumbnail: revolution_1,
		// video: revolution_clip,
		banner: revolution_banner,
		brands: ['bulgari','tribeca_Festival_logo'],
		songs: [],
		// clips: [{name:'Trailer',video:revolution_clip}],
		clips: [{name:'Conducting A Revolution',spanClass:'wistia_embed wistia_async_uz7y856qzs popover=true popoverAnimateThumbnail=true',still:conducting_still}],
		links: [{name:'The Hollywood Reporter',link:'https://www.hollywoodreporter.com/video/bulgari-x-tribeca-film-festival-1101993/'}],
	},
	{
		id: 14,
		name: 'Adventure park',
		description: `Once there was a magical park where kids of all ages could run the Serengeti with the Great Beasts, ride the haunted rails of a Wild-West Ghost Train, explore Lost Atlantis, shrink to the size of a Hard Candy, and journey to the heart of a Black Hole... All in a single, magical day! But then there was an accident, and the doors to Adventure Park slammed shut forever. Now, three friends must embark on a daring adventure of their own: returning to the long- abandoned fantasy park to save their missing friend.`,
		points: [],
		info: [`Adventure Park`,`Zag Animation Studios`,`Spec Story Board Pitch`],
		thumbnail: ladybug_3,
		banner: ladybug_animation_banner,
		brands: ['ZAG_Logo',],
		songs: [{audio:ladybug_song_2,name:'Adventure Park Theme'}],
		clips: [{name:'',spanClass:'wistia_embed wistia_async_j8fdtfj0wx popover=true popoverAnimateThumbnail=true',still:ladybug_animation_banner}],
		links: [{name:'Learn more',link:'https://zagtoon.fandom.com/wiki/Adventure_Park'}],
	},

	{
		id: 10,
		name: 'Gabe',
		director: 'Directed by Luke Terrell',
		points: ['Directed by Luke Terrell',],
		description: `Gabe Weil is a 27 year old born with the most severe form of muscular dystrophy. For his entire life, Gabe had been told he would be lucky to live past 25. But recently, he learned he was misdiagnosed, and may live well into his 50's.`,
		info: [`Gabe (2017)`,`Directed by Luke Terrell`,`Gravitas Ventures`,`Submarine`,`Amazon Prime`,`Composer`],
		thumbnail: gabe_3,
		// video: gabe_clip_2,
		banner: gabe_banner,
		brands: ['prime'],
		songs: [{audio:gabe_song_1,name:'Man & The Machine'},{audio:gabe_song_2,name:'Choking'},{audio:gabe_song_3,name:'Childhood Memories'},{audio:gabe_song_4,name:'Iron Lungs'}],
		// clips: [{name:'Gabe - choking',video:gabe_clip_2}],
		clips: [{name:'Gabe - choking',spanClass:'wistia_embed wistia_async_qhfmo670tj popover=true popoverAnimateThumbnail=true',still:choke_still},
				{name:'Man & The Machine',spanClass:'wistia_embed wistia_async_ai2hvn5c4x popover=true popoverAnimateThumbnail=true',still:opening_still},
				{name:'Iron Lungs',spanClass:'wistia_embed wistia_async_wz4z3h0ojq popover=true popoverAnimateThumbnail=true',still:ironlung_still}],
		link: [{name:'Watch on Amazon',link:'https://www.amazon.com/Gabe-Weil/dp/B07FN62W15'}],
	},
	{
		id: 12,
		name: 'Voice Through The Storm',
		director: 'Directed by Bella Monticelli-McTiernan',
		points: ['Directed by Bella Monticelli-McTiernan'],
		description: `In September 2017, two Category 5 hurricane hit and destroyed the majority of ST THOMAS - a small island of 51,000 residents in the US Virgin Islands. As people wait for aid that doesn’t come, there is no cell reception; the generators that power the towers have run out of diesel; internet is non existent. The only way to communicate is through a dilapidated radio station - AM 1340. At dawn, through the destruction, there is a voice. A voice coming through the radio guiding people through the storm and its aftermath. This voice belongs to ADDIE OTTLEY, a 74 year old man who is dying.  This is his story.`,
		info: [`Voice Through The Storm`,`Directed by Bella Monticelli-McTiernan`,`Mumford & Sons`,`Tribeca Film Festival`,`Composer`],
		thumbnail: voicethroughstorm,
		// video: voicethroughstorm_clip,
		banner: voicethroughstorm_banner,
		brands: ['tribeca_Festival_logo'],
		songs: [],
		// clips: [{name:'Voice Through The Storm clip',video:voicethroughstorm_clip}],
		clips: [{name:'Voice Through The Storm clip',spanClass:'wistia_embed wistia_async_nwy2bvlpn8 popover=true popoverAnimateThumbnail=true',still:voicethroughstorm_still}],
		links: [{name:'Learn more',link:'https://www.mohawkhudsonfilms.com/the-voice-through-the-storm'}],
	},
	{
		id: 13,
		name: 'Ladybug',
		points: [],
		description: `Miraculous: Tales of Ladybug & Cat Noir (also known as Miraculous Ladybug or Miraculous) is a computer-animated magical girl superhero children's television series. The series focuses on two Parisian teenagers, Marinette Dupain-Cheng and Adrien Agreste, who transform into the superheroes Ladybug and Cat Noir, respectively, to protect the city from supervillains.`,
		info: [`LadyBug`,`Disney`,`Zag Animation Studios`,`theme song pitch`,],
		thumbnail: ladybug,
		banner: ladybug_banner,
		brands: ['ZAG_Logo',],
		songs: [{audio:ladybug_song_1,name:'Ladybug Theme'}],
		// clips: [ladybug_clip],
		clips: [{name:'Ladybug clip',spanClass:'wistia_embed wistia_async_kdlv6qqc54 popover=true popoverAnimateThumbnail=true',still:ladybug_still}],
		links: [{name:'Learn more',link:'https://www.zag-inc.com/#home'}],
	},
	{
		id: 15,
		name: 'This Remains',
		director: 'Directed by Sosie Bacon & Rachel Borders',
		points: ['Directed by Sosie Bacon & Rachel Borders'],
		description: `Two estranged half-sisters travel to the desert to scatter their mother's ashes. Their relationship comes to a head when they can't get the urn open.`,
		info: [`This Remains`,`Directed by Sosie Bacon & Rachel Borders`,`Composer`],
		thumbnail: thisremains,
		// video: thisremains_clip,
		banner: thisremains_banner,
		brands: [],
		songs: [{audio:remains_song_1,name:'Sisterly Banter'},{audio:remains_song_2,name:'Family Ties'},{audio:remains_song_3,name:'All Is Forgiven'}],
		// clips: [{name:'This Remains clip',video:thisremains_clip}],
		clips: [{name:'This Remains',spanClass:'wistia_embed wistia_async_12nbi4wpnx popover=true popoverAnimateThumbnail=true',still:remains_still}],
		links: [{name:'Learn more',link:'https://www.google.com/url?q=https://www.imdb.com/title/tt7654534/?ref_%3Dnm_flmg_act_10&sa=D&source=editors&ust=1661847236673793&usg=AOvVaw3-IRprhIcuokCQYUvx_iYR'}],
	},
	{
		id: 11,
		name: 'Lost Boy',
		director: 'Directed by Bella Monticelli-McTiernan',
		points: ['Directed by Bella Monticelli-McTiernan'],
		description: 'A story about life in the US/Mexico Caravan Refugee Camps, and the human will to persevere.',
		info: [`Lost Boy`,`Directed by Bella Monticelli-McTiernan`,`Composer`],
		thumbnail: lostboys_4,
		// video: lostboys_clip_2,
		banner: lostboys_banner,
		brands: [],
		songs: [],
		// clips: [{name:'The Lost Boy clip 2',video:lostboys_clip_2}],
		clips: [{name:'The Lost Boy clip 2',spanClass:'wistia_embed wistia_async_mc5hffk10h popover=true popoverAnimateThumbnail=true',still:lostboy_still}],
	},
	{
		id: 5,
		name: 'Master Chef',
		points: ['Hosted by Gordan Ramsey','Created by Franc Roddam','Producers: Justin Brooks; Jefferson Strouse'],
		description: 'MasterChef is an American competitive cooking reality TV show based on the British series of the same name, open to amateur and home chefs.',
		info: [`Master Chef (2021)`,`Fox`,`Bleeding Fingers`,`Additional Music`],
		thumbnail: masterchef_3,
		banner: masterchef_banner,
		brands: ['masterchef','fox','bleeding_fingers'],
		songs: [{name:'Master chef track 1',audio:masterchef_audio}],
		clips: [],
		link: '',
	},
	

	{
		id: 3,
		name: 'Full Bloom',
		points: [],
		description: 'This vibrant competition series follows ten fabulous up-and-coming florists as they compete for a career-changing $100,000 grand prize to kickstart their business and make the world a little bit more beautiful.',
		info: ['Full Bloom (2022)','HBO Max','Bleeding Fingers','Additional music'],
		thumbnail: full_bloom,
		banner: fullbloom_banner,
		brands: ['hbo_max','bleeding_fingers'],
		songs: [],
		clips: [],
		link: 'https://www.imdb.com/title/tt11210490/',
	},
	{
		id: 4,
		name: 'FoodTastic',
		points: ['Hosted by Keke Palmer'],
		description: `Three teams of food artists transform iconic characters into extravagant masterpieces that tell a story from Disney's legendary IP. The food sculptures will be judged on their design, technical skills and narrative, and not by taste. Unused food from each competition will be donated to local food banks.`,
		info: [`FoodTastic (2022)`,`Disney +`,`Bleeding Fingers`,`Additional Music`],
		thumbnail: foodtastic,
		banner: foodtastic_banner,
		brands: ['disney_plus_logo','bleeding_fingers'],
		songs: [],
		clips: [],
		link: 'https://disneyplusoriginals.disney.com/show/foodtastic',
	},
	

	{
		id: 7,
		name: 'One Heart',
		points: [],
		description: 'A football team, made up of juvenile offenders, and a small town football coach who made a decision that would change the lives of the players on the field that night. Based on a true story.',
		info: [`One Heart: The Movie (2021)`,`Rodney Jerkins`,`Bleeding Fingers`,`Lifetime Channel`,`Co-Composer`],
		thumbnail: one_heart_3,
		banner: oneheart_banner,
		// brands: ['bbc','bleeding_fingers'],
		songs: [],
		clips: [],
	},
	

]

export default FilmScoreData;






